<template>
  <div
    v-if="adv">
    <div class="is-border-top">
      <div
        class="columns is-align-items-flex-start"
        style="position:relative;">
        <div
          v-if="adv.status==='canceled' || !plan.adv_enabled || !adv.promoteur.plan.adv_enabled"
          class="frontdrop"></div>
        <div class="column is-6 is-paddingless is-border-left">
          <div class="has-background-white is-border-right">
            <div class="row-width-actions-bar columns is-gapless is-vcentered is-marginless">
              <div class="column is-padding-left">
                <!-- has-text-dark -->
                <span class="has-text-dark title is-6 has-text-weight-normal">Suivi de vente ({{ (loansLength + signatureLength + notaireLength + saleDocumentsLength + advDocumentsLength + advMandatDeGestionLength)|pluralize }})</span>
              </div>
              <div class="column is-narrow is-border-left">
                <button
                  class="page-header-btn is-small is-square"
                  @click="toggleTable('sales_follow')">
                  <span class="icon is-size-4 has-text-dark">
                    <i
                      class="fal "
                      :class="open.sales_follow ? 'fa-times' :'fa-chevron-down'"></i></span>
                </button>
              </div>
            </div>
            <div
              class="column is-12 is-border-top is-padding"
              v-if="displaySalesFollowList > 0"
              v-show="open.sales_follow === true">
              <div
                class="field"
                v-if="advDocuments && advDocumentsLength">
                <view-file-list
                  :documents="advDocuments"
                  :is-array="true"
                  :can-drag="false"
                  :can-edit="isAdmin && isPromoteur"
                  :edit-display-enabled="isAdmin && isPromoteur"
                  @update="val => updateDocument(val, 'documents', 'adv')"></view-file-list>
              </div>
              <div
                class="field"
                v-if="loansDocuments && sale && 'funding_data' in sale && sale.funding_data.loans && sale.funding_data.loans.length">
                <view-file-list
                  :documents="loansDocuments"
                  :is-array="true"
                  :can-drag="false"
                  :can-edit="isAdmin && isPromoteur"
                  :edit-display-enabled="isAdmin && isPromoteur"
                  @update="val => updateLoansDocument(val)"></view-file-list>
              </div>
              <div
                class="field"
                v-if="notaireDocuments">
                <view-file-list
                  :documents="notaireDocuments"
                  :is-array="true"
                  :can-drag="false"
                  :can-edit="isAdmin && isPromoteur"
                  :edit-display-enabled="isAdmin && isPromoteur"
                  @update="val => updateNotaireDocument(val)"></view-file-list>
              </div>
              <div
                class="field"
                v-if="signatureDocument">
                <view-file-list
                  :documents-object="signatureDocument"
                  :can-drag="false"
                  :can-edit="isAdmin && isPromoteur"
                  :edit-display-enabled="isAdmin && isPromoteur"
                  @update="val => updateDocument(val, 'signed_contract', 'adv')"></view-file-list>
              </div>
              <div
                class="field"
                v-if="sale.documents && saleDocumentsLength">
                <view-file-list
                  :documents="saleDocuments"
                  :is-array="true"
                  :can-drag="false"
                  :can-edit="isAdmin && isPromoteur"
                  :edit-display-enabled="isAdmin && isPromoteur"
                  @update="val => updateDocument(val, 'documents', 'sale')"></view-file-list>
              </div>
              <div
                class="field"
                v-if="adv.mandat_de_gestion_file && advMandatDeGestionLength">
                <view-file-list
                  :documents-object="adv.mandat_de_gestion_file"
                  :can-drag="false"
                  :can-edit="isAdmin && isPromoteur"
                  :edit-display-enabled="isAdmin && isPromoteur"
                  @update="val => updateDocument(val, 'mandat_de_gestion_file', 'adv')"></view-file-list>
              </div>
            </div>
          </div>
          <div
            v-if="listLength || tmaArchi || tmaAccepted || tmaPromoteur "
            class="has-background-white is-border-right is-border-top">
            <div class="row-width-actions-bar columns is-gapless is-vcentered is-marginless">
              <div class="column is-padding-left">
                <!-- has-text-dark -->
                <span class="has-text-dark title is-6 has-text-weight-normal">Choix et tma ({{ listLength + tmaArchi + tmaAccepted + tmaPromoteur | pluralize }})</span>
              </div>
              <div class="column is-narrow is-border-left">
                <button
                  class="page-header-btn is-small is-square"
                  @click="toggleTable('tma')">
                  <span class="icon is-size-4 has-text-dark">
                    <i
                      class="fal "
                      :class="open.tma ? 'fa-times' :'fa-chevron-down'"></i></span>
                </button>
              </div>
            </div>
            <div
              class="column is-12 is-border-top is-padding"
              v-if=" listLength || tmaArchi || tmaAccepted || tmaPromoteur "
              v-show="open.tma === true">
              <div
                class="field"
                v-if="sale && 'choix_et_tma' in sale && sale.choix_et_tma.tma.architect_devis.document">
                <view-file-list
                  :documents-object="sale.choix_et_tma.tma.architect_devis.document"
                  :can-drag="false"
                  :can-edit="isAdmin && isPromoteur"
                  :edit-display-enabled="isAdmin && isPromoteur"
                  @update="val => updateTma(val, 'architect_devis')"></view-file-list>
              </div>
              <div
                class="field"
                v-if="sale && 'choix_et_tma' in sale && sale.choix_et_tma.tma.accepted_devis.document">
                <view-file-list
                  :documents-object="sale.choix_et_tma.tma.accepted_devis.document"
                  :can-drag="false"
                  :can-edit="isAdmin && isPromoteur"
                  :edit-display-enabled="isAdmin && isPromoteur"
                  @update="val => updateTma(val, 'accepted_devis')"></view-file-list>
              </div>
              <div
                class="field"
                v-if="sale && 'choix_et_tma' in sale && sale.choix_et_tma.tma.promoteur_devis.document">
                <view-file-list
                  :documents-object="sale.choix_et_tma.tma.promoteur_devis.document"
                  :can-drag="false"
                  :can-edit="isAdmin && isPromoteur"
                  :edit-display-enabled="isAdmin && isPromoteur"
                  @update="val => updateTma(val, 'promoteur_devis')"></view-file-list>
              </div>
              <div
                class="field"
                v-if="listLength">
                <view-file-list
                  :documents="listDocuments"
                  :is-array="true"
                  :can-drag="false"
                  :can-edit="isAdmin && isPromoteur"
                  :edit-display-enabled="isAdmin && isPromoteur"
                  @update="val => updateListDocument(val)"></view-file-list>
              </div>
            </div>
          </div>
          <div
            v-if="adv.misc_documents"
            class="has-background-white is-border-right is-border-top">
            <div class="row-width-actions-bar columns is-gapless is-vcentered is-marginless">
              <div class="column is-padding-left">
                <!-- has-text-dark -->
                <span class="has-text-dark title is-6 has-text-weight-normal">Documents Divers ({{ miscDocumentsLength| pluralize }})</span>
              </div>
              <div class="column is-narrow is-border-left">
                <button
                  class="page-header-btn is-small is-square"
                  @click="toggleTable('other')">
                  <span class="icon is-size-4 has-text-dark">
                    <i
                      class="fal "
                      :class="open.other ? 'fa-times' :'fa-chevron-down'"></i></span>
                </button>
              </div>
            </div>
            <div
              class="column is-12 is-border-top is-padding"
              v-if="miscDocumentsLength "
              v-show="open.other === true">
              <div
                class="field"
                v-if="miscDocuments && miscDocumentsLength">
                <view-file-list
                  :documents="miscDocuments"
                  :is-array="true"
                  :can-drag="false"
                  :can-edit="isAdmin && isPromoteur"
                  :edit-display-enabled="isAdmin && isPromoteur"
                  @update="val => updateDocument(val, 'misc_documents', 'adv')"></view-file-list>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="isAdmin && isPromoteur"
          class="column is-6 is-paddingless">
          <div class="notification is-warning has-text-centered is-marginless">
            <p class="is-uppercase is-size-7">
              <span class="icon"><i class="fas fa-exclamation-circle"></i></span>
              Seuls les fichiers au formats images sont autorisés (ex : .pdf, .jpeg, .png ...)
            </p>
          </div>
          <div class="field">
            <upload-file
              :multiple="true"
              @upload="uploadDocument"
              :placeholder="'Sélectionnez ou déposez documents'"
              :source-documents="adv.documents"
              :show-list="false"
              :is-large="true"></upload-file>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Adv } from '@/mixins'
import uuidv4 from 'uuid/v4'
import { clone } from 'lodash'

export default {
  name: 'Documents',
  components: {
    ViewFileList: () => import('./ViewFileList')
  },
  filters: {
    pluralize (v) {
      if (v > 1) return `${v} documents`
      else return `${v} document`
    }
  },
  mixins: [Adv],
  data () {
    return {
      open: {
        seller: false,
        tma: false,
        other: false,
        sales_follow: false
      }
    }
  },
  computed: {
    /**
      * is tma archi doc
      * @return {number}
      */
    tmaArchi () {
      if (this.sale && 'choix_et_tma' in this.sale && this.sale.choix_et_tma.tma.architect_devis.document && (('destination' in this.sale.choix_et_tma.tma.architect_devis.document && this.sale.choix_et_tma.tma.architect_devis.document.destination && this.sale.choix_et_tma.tma.architect_devis.document.destination.includes('display_in_adv')) || (this.isAdmin && this.isPromoteur))) {
        return 1
      } else {
        return 0
      }
    },
    /**
      * is tma accepted doc
      * @return {number}
      */
    tmaAccepted () {
      if (this.sale && 'choix_et_tma' in this.sale && this.sale.choix_et_tma.tma.accepted_devis.document && (('destination' in this.sale.choix_et_tma.tma.accepted_devis.document && this.sale.choix_et_tma.tma.accepted_devis.document.destination && this.sale.choix_et_tma.tma.accepted_devis.document.destination.includes('display_in_adv')) || (this.isAdmin && this.isPromoteur))) {
        return 1
      } else {
        return 0
      }
    },
    /**
      * is tma promoteur doc
      * @return {number}
      */
    tmaPromoteur () {
      if (this.sale && 'choix_et_tma' in this.sale && this.sale.choix_et_tma.tma.promoteur_devis.document && (('destination' in this.sale.choix_et_tma.tma.promoteur_devis.document && this.sale.choix_et_tma.tma.promoteur_devis.document.destination && this.sale.choix_et_tma.tma.promoteur_devis.document.destination.includes('display_in_adv')) || (this.isAdmin && this.isPromoteur))) {
        return 1
      } else {
        return 0
      }
    },
    /**
      * loans length
      * @return {number}
      */
    loansLength () {
      return this.loansDocuments.length
    },
    /**
      * list length
      * @return {number}
      */
    listLength () {
      return this.listDocuments.length
    },
    /**
      * notaire length
      * @return {number}
      */
    notaireLength () {
      return this.notaireDocuments.length
    },
    /**
      * signature length
      * @return {number}
      */
    signatureLength () {
      if (this.signatureDocument) {
        return 1
      } else {
        return 0
      }
    },
    /**
      * adv documents length
      * @return {number}
      */
    advDocumentsLength () {
      return this.advDocuments.length
    },
    /**
      * sale documents length
      * @return {number}
      */
    saleDocumentsLength () {
      return this.saleDocuments.length
    },
    /**
      * adv mandat de gestion length
      * @return {number}
      */
    advMandatDeGestionLength () {
      return this.advMandatDeGestion.length
    },
    /**
      * misc document length
      * @return {number}
      */
    miscDocumentsLength () {
      return this.miscDocuments.length
    },
    /**
      * display sale follow list
      * @return {boolean}
      */
    displaySalesFollowList () {
      return this.loansLength || this.notaireLength || this.saleDocumentsLength || this.advDocumentsLength || this.advMandatDeGestionLength || this.signatureLength
    }
  },
  created () {
    if (this.displaySalesFollowList > 0 && this.isAdmin && this.isPromoteur) {
      this.toggleTable('sales_follow')
    }
  },
  methods: {
    /**
      * toogle table
      * @param {string} v - elem to open
      */
    toggleTable (v) {
      this.$set(this.open, v, !this.open[v])
    },
    /**
      * update tma
      * @param {string} value - elem to open
      * @param {string} from - which tma
      */
    async updateTma (value, from) {
      try {
        this.sale.choix_et_tma.tma[from].document = value
        await this.$store.commit('modifyCurrentSale', { key: `sale.choix_et_tma.tma[${from}].document`, value })
        await this.$store.dispatch('updateCurrentSale')
        this.$toasted.global.success('Document modifié')
      } catch (err) {
        this.$toasted.global.danger('Erreur lors de la modification')
      }
    },
    /**
      * update document
      * @param {string} value
      * @param {string} key
      * @param {string} obj
      */
    async updateDocument (value, key, obj) {
      if (obj === 'sale') {
        try {
          await this.$store.commit('modifyCurrentSale', { key, value })
          await this.$store.dispatch('updateCurrentSale')
          this.$toasted.global.success('Document modifié')
        } catch (err) {
          this.$toasted.global.danger('Erreur lors de la modification')
        }
      } else {
        let documents
        if (key === 'documents') {
          documents = value.map(x => {
            return {
              key: uuidv4(),
              name: x.filename,
              document: x
            }
          })
        } else {
          documents = value
        }
        try {
          await this.$store.commit('modifyCurrentAdv', { key, value: documents })
          await this.$store.dispatch('updateCurrentAdv')
          this.$toasted.global.success('Document modifié')
        } catch (err) {
          console.log(err)
          this.$toasted.global.danger('Erreur lors de la modification')
        }
      }
    },
    /**
      * upload document
      * @param {object} data
      */
    async uploadDocument (data) {
      let newDocs = this.adv.misc_documents.concat(data)
      try {
        await this.$store.commit('modifyCurrentAdv', { key: 'misc_documents', value: newDocs })
        await this.$store.dispatch('updateCurrentAdv')
        this.$toasted.global.success('Le document à été téléchargé avec succès')
        this.open.other = true
      } catch (err) {
        this.$toasted.global.danger('Erreur lors du téléchargement')
      }
    },
    /**
      * update notaire document
      * @param {array} val
      */
    async updateNotaireDocument (val) {
      let documents
      if (Array.isArray(val)) {
        documents = val.map(x => {
          return {
            key: uuidv4(),
            name: x.filename,
            document: x
          }
        })
      } else {
        documents = val
      }
      let notaryData = this.sale.notary_data
      notaryData.documents = documents
      try {
        await this.$store.commit('modifyCurrentSale', { key: 'notary_data', value: notaryData })
        await this.$store.dispatch('updateCurrentSale')
        this.$toasted.global.success('Document modifié')
      } catch (err) {
        this.$toasted.global.danger('Erreur lors de la modification')
      }
    },
    /**
      * update loans document
      * @param {array} val
      */
    updateLoansDocument (val) {
      let documents = {}
      for (let document of val) {
        documents[document.fus_id] = document
      }
      let fundingData = clone(this.sale.funding_data)
      for (let [index, loan] of Object.entries(fundingData.loans)) {
        if (documents[loan.document.fus_id]) {
          fundingData.loans[index].document = documents[loan.document.fus_id]
        } else {
          fundingData.loans[index].document = null
        }
      }
      try {
        this.$store.commit('modifyCurrentSale', { key: 'funding_data', value: fundingData })
        this.$store.dispatch('updateCurrentSale')
        this.$toasted.global.success('Document modifié')
      } catch (err) {
        console.log(err)
        this.$toasted.global.danger('Erreur lors de la modification')
      }
    },
    /**
      * update list document suppression and modification
      * @param {array} val
      */
    updateListDocument (val) {
      let choixEtTma = clone(this.sale.choix_et_tma)
      for (let choice of choixEtTma.choices) {
        if (choice.document !== null) {
          for (let value of val) {
            if (choice.document.fus_id === value.fus_id) {
              choice.document = value
            }
          }
          // test if choice is in the value if not it signify someone click on the supression
          if (val.filter(value => value.fus_id === choice.document.fus_id).length === 0) {
            choice.document = null
          }
        }
      }
      try {
        this.$store.commit('modifyCurrentSale', { key: 'choix_et_tma', value: choixEtTma })
        this.$store.dispatch('updateCurrentSale')
        this.$toasted.global.success('Document modifié')
      } catch (err) {
        console.log(err)
        this.$toasted.global.danger('Erreur lors de la modification')
      }
    },
    /**
      * save documents
      * store action updateCurrentSale
      */
    saveDocuments () {
      this.$store.dispatch('updateCurrentSale')
    }
  }
}
</script>
